export const BASE_PATH =
  process.env.REACT_APP_BASE_PATH || 'http://localhost:3977/api';
export const API_VERSION = process.env.REACT_APP_API_VERSION || 'v1';
